import { clsx } from 'clsx'

import { Card } from '@tribeplatform/react-ui-kit/Card'
import { SvgIcon, type SvgIconName } from '@tribeplatform/react-ui-kit/Icon'

interface Props {
  name: string
  iconName: SvgIconName
  active: boolean
  onClick: () => void
}
export const FieldOption = ({ name, iconName, active, onClick }: Props) => {
  return (
    <Card
      padding="sm"
      // overriding theme
      className={clsx(
        'border cursor-pointer',
        active ? '!border-action-primary' : 'border-line',
      )}
      transparent
      onClick={onClick}
    >
      <div className="flex flex-col gap-y-2 p-3">
        <SvgIcon name={iconName} size="lg" />
        <div className="text-sm font-semibold">{name}</div>
      </div>
    </Card>
  )
}
